module.exports = __webpack_public_path__ + "static/media/p11.4ea76285.jpg";